import { t } from 'i18next';

import { IngestionSourceParametersType, ProjectSourceModel } from '../../gamma-api';
import { IbIconName } from '../components/common/IbIcon';

export const getSourceTypeIconName = (type?: IngestionSourceParametersType | null): IbIconName => {
  if (
    type === IngestionSourceParametersType.WebsiteUrls ||
    type === IngestionSourceParametersType.WebsiteCrawler ||
    type === IngestionSourceParametersType.Website
  ) {
    return 'international';
  }

  if (type === IngestionSourceParametersType.File) {
    return 'paperclip';
  }

  if (type === IngestionSourceParametersType.Elma365) {
    return 'elma365';
  }

  if (type === IngestionSourceParametersType.Confluence) {
    return 'confluence';
  }

  return 'paperclip';
};

export const getSourceTypeName = (type: IngestionSourceParametersType): string => t(`Source type: ${type}`);

export const getSourceItemName = (source: ProjectSourceModel): string => {
  const typeName = getSourceTypeName(source.type);
  return source.name ? `${typeName}: ${source.name}` : typeName;
};
